if ($("#szkolenia").length != 0) {
  Highcharts.chart("szkolenia", {
    chart: {
      type: "column",
      style: {
        fontFamily: "Open Sans, sans-serif",
      },
    },
    title: {
      text: "Szkolenia",
      style: {
        fontFamily: "Open Sans, sans-serif",
        fontSize: "18px",
        fontWeight: "bold",
        fontStyle: "normal",
        color: "#000",
      },
    },
    xAxis: {
      categories: [
        "Liczba  szkoleń wewnętrznych*",
        "Liczba wszystkich uczestników",
        "Liczba unikalnych uczestników",
        "Liczba godzin szkoleniowych",
      ],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    tooltip: {
      useHTML: true,
      backgroundColor: "#fff",
      borderColor: "#ababad",
      headerFormat: '<div style="width:115px; white-space:normal; text-align:center; line-height: 1.4"><div style="margin-bottom: 4px;"></div>',
      pointFormat: ' <div style="margin-top: 2px;"><b>{point.y}</b><br/>spotkań</div></div>',
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    legend: {
      itemStyle: {
        fontFamily: "Open Sans, sans-serif",
        fontSize: "14px",
        fontWeight: "normal",
        fontStyle: "normal",
        color: "#000",
      },
    },
    colors: ["#dddddd", "#3c6bb9"],
    series: [{
        name: "2018",
        data: [295, 2870, 1893, 1942],
      },
      {
        name: "2019",
        data: [443, 4416, 1386, 2647],
      },
    ],
  });
}
if ($("#szkolenia-en").length != 0) {
  Highcharts.chart("szkolenia-en", {
    chart: {
      type: "column",
      style: {
        fontFamily: "Open Sans, sans-serif",
      },
    },
    title: {
      text: "Trainings",
      style: {
        fontFamily: "Open Sans, sans-serif",
        fontSize: "18px",
        fontWeight: "bold",
        fontStyle: "normal",
        color: "#000",
      },
    },
    xAxis: {
      categories: [
        "Number of internal coaches",
        "Total number of participants",
        "The number of unique participants ",
        "Number of training hours",
      ],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    tooltip: {
      useHTML: true,
      backgroundColor: "#fff",
      borderColor: "#ababad",
      headerFormat: '<div style="width:115px; white-space:normal; text-align:center; line-height: 1.4"><div style="margin-bottom: 4px;"></div>',
      pointFormat: ' <div style="margin-top: 2px;"><b>{point.y}</b><br/>meetings</div></div>',
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    legend: {
      itemStyle: {
        fontFamily: "Open Sans, sans-serif",
        fontSize: "14px",
        fontWeight: "normal",
        fontStyle: "normal",
        color: "#000",
      },
    },
    colors: ["#dddddd", "#3c6bb9"],
    series: [{
        name: "2018",
        data: [295, 2870, 1893, 1942],
      },
      {
        name: "2019",
        data: [443, 4416, 1386, 2647],
      },
    ],
  });
}

if ($("#slad-weglowy").length != 0) {
  Highcharts.chart("slad-weglowy", {
    chart: {
      type: "column",
      style: {
        fontFamily: "Open Sans, sans-serif",
      },
    },
    title: {
      text: "Ślad węglowy Allegro 2019 vs 2018",
      style: {
        fontFamily: "Open Sans, sans-serif",
        fontSize: "18px",
        fontWeight: "bold",
        fontStyle: "normal",
        color: "#000",
      },
    },
    xAxis: {
      categories: [
        "emisja pośrednia",
        "pozostała emisja pośrednia",
        "emisja bezpośrednia",
      ],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    tooltip: {
      useHTML: true,
      backgroundColor: "#fff",
      borderColor: "#ababad",
      headerFormat: '<div style="width:115px; white-space:normal; text-align:center; line-height: 1.4"><div style="margin-bottom: 4px;"></div>',
      pointFormat: ' <div style="margin-top: 2px;"><b>{point.y}%</b></div></div>',
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    legend: {
      itemStyle: {
        fontFamily: "Open Sans, sans-serif",
        fontSize: "14px",
        fontWeight: "normal",
        fontStyle: "normal",
        color: "#000",
      },
    },
    colors: ["#dddddd", "#00a790"],
    series: [{
        name: "2018",
        data: [88.5, 4.8, 6.6],
      },
      {
        name: "2019",
        data: [90.2, 6.4, 3.4],
      },
    ],
  });
}

if ($("#slad-weglowy-en").length != 0) {
  Highcharts.chart("slad-weglowy-en", {
    chart: {
      type: "column",
      style: {
        fontFamily: "Open Sans, sans-serif",
      },
    },
    title: {
      text: "Allegro’s carbon footprint 2019 versus 2018",
      style: {
        fontFamily: "Open Sans, sans-serif",
        fontSize: "18px",
        fontWeight: "bold",
        fontStyle: "normal",
        color: "#000",
      },
    },
    xAxis: {
      categories: [
        "indirect emissions ",
        "other indirect emissions ",
        "direct emissions ",
      ],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    tooltip: {
      useHTML: true,
      backgroundColor: "#fff",
      borderColor: "#ababad",
      headerFormat: '<div style="width:115px; white-space:normal; text-align:center; line-height: 1.4"><div style="margin-bottom: 4px;"></div>',
      pointFormat: ' <div style="margin-top: 2px;"><b>{point.y}%</b></div></div>',
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    legend: {
      itemStyle: {
        fontFamily: "Open Sans, sans-serif",
        fontSize: "14px",
        fontWeight: "normal",
        fontStyle: "normal",
        color: "#000",
      },
    },
    colors: ["#dddddd", "#00a790"],
    series: [{
        name: "2018",
        data: [88.5, 4.8, 6.6],
      },
      {
        name: "2019",
        data: [90.2, 6.4, 3.4],
      },
    ],
  });
}

if ($("#liczba-spotkan").length != 0) {
  Highcharts.chart("liczba-spotkan", {
    chart: {
      type: "column",
      style: {
        fontFamily: "Open Sans, sans-serif",
      },
    },
    title: {
      text: "Liczba spotkań",
      style: {
        fontFamily: "Open Sans, sans-serif",
        fontSize: "18px",
        fontWeight: "bold",
        fontStyle: "normal",
        color: "#000",
      },
    },
    xAxis: {
      categories: ["webinary", "stacjonarne"],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    tooltip: {
      useHTML: true,
      backgroundColor: "#fff",
      borderColor: "#ababad",
      headerFormat: '<div style="width:115px; white-space:normal; text-align:center; line-height: 1.4"><div style="margin-bottom: 4px;"></div>',
      pointFormat: ' <div style="margin-top: 2px;"><strong>{point.y}</strong><br/>spotkań</div></div>',
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    legend: {
      itemStyle: {
        fontFamily: "Open Sans, sans-serif",
        fontSize: "14px",
        fontWeight: "normal",
        fontStyle: "normal",
        color: "#000",
      },
    },
    colors: ["#dddddd", "#6a54a4"],
    series: [{
        name: "2018",
        data: [47, 60],
      },
      {
        name: "2019",
        data: [76, 70],
      },
    ],
  });
}

if ($("#liczba-uczestnikow").length != 0) {
  Highcharts.chart("liczba-uczestnikow", {
    chart: {
      type: "column",
      style: {
        fontFamily: "Open Sans, sans-serif",
      },
    },
    title: {
      text: "Liczba uczestników",
      style: {
        fontFamily: "Open Sans, sans-serif",
        fontSize: "18px",
        fontWeight: "bold",
        fontStyle: "normal",
        color: "#000",
      },
    },
    xAxis: {
      categories: ["webinary", "stacjonarne"],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    tooltip: {
      useHTML: true,
      backgroundColor: "#fff",
      borderColor: "#ababad",
      headerFormat: '<div style="width:115px; white-space:normal; text-align:center; line-height: 1.4"><div style="margin-bottom: 4px;"></div>',
      pointFormat: ' <div style="margin-top: 2px;"><strong>{point.y}</strong><br/>uczestników</div></div>',
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    legend: {
      itemStyle: {
        fontFamily: "Open Sans, sans-serif",
        fontSize: "14px",
        fontWeight: "normal",
        fontStyle: "normal",
        color: "#000",
      },
    },
    colors: ["#dddddd", "#6a54a4"],
    series: [{
        name: "2018",
        data: [3565, 988],
      },
      {
        name: "2019",
        data: [7812, 1143],
      },
    ],
  });
}